import React, { useEffect, useState } from "react"; import { Button, Row, Col, Container, Form } from 'react-bootstrap'; import { useNavigate } from "react-router-dom"; import 'bootstrap/dist/css/bootstrap.min.css';
import { Field, FormikProvider, useFormik } from "formik"; import { ImNewTab } from "react-icons/im"; import { RiFileExcel2Line } from "react-icons/ri"; import { VscFilePdf } from "react-icons/vsc"; import { CiFloppyDisk } from "react-icons/ci";
import MasterService from '../../Services/MasterService'; import SwaranandhraService from '../../Services/SwaranandhraService'; import { store } from '../../App'; import ShowAlert from '../alert';
import Menubar from "../Menubar"; import { generateindicatorpdf, exportToExcelindicator } from "../utils/commonFunctions"; import autoTable from "jspdf-autotable";


function IndicatorMapping() {
  const [indicatorlist, setIndicatorlist] = useState(); const [indicatorslist, setIndicatorslist] = useState(); const [indicatorname, setIndicatorname] = useState(); const [data, setData] = useState([]);
  const [data1, setData1] = useState([]); const [searchText, setSearchText] = useState(""); const [searchText1, setSearchText1] = useState("")
  const [start, setStart] = useState(0); const [indicatorStart, setIndicatorStart] = useState("");



  let username = localStorage.getItem("username"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid");


  const formik = useFormik({
    initialValues: {
      indicator_id: "", checkall: "", checkdata: [], checkdata1: []
    },

  })



  useEffect(() => {
    fetchIndicators(); fetchIndicatorMapping();
  }, []);


  const filteredData = searchText1.length > 0 ? data?.filter((item) => {
    return (
      item &&
      Object.keys(item).some((key) => {
        const value = item[key];
        return ( value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()) );
      })
    );
  }) : data;

  const filteredData1 = searchText.length > 0 ? data1?.filter((item) => {
    return (
      item &&
      Object.keys(item).some((key) => {
        const value = item[key];
        return ( value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()) );
      })
    );
  }) : data1;

  const fetchIndicators = async () => {
    const res = await MasterService.getIndicators();
    if (res.data) {
      const list = Object.keys(res.data).map((key) => ({
        key,
        id: res.data[key]?.id,
        value: res.data[key]?.value,
      }));
      setIndicatorlist(list);
      const options = res.data.map((item, i) => (
        <option key={i} value={item.id}> {item.value} </option>
      ));
      setIndicatorslist(options);
    }
  };




  const fetchIndicatorMapping = async () => {
    const params = {
      userId: username,
      district_id: district,
      mandal_id: mandal,
      button_type: "getData"
    };
    const res = await SwaranandhraService.getIndicatorMandalMapping(params);
    setData1(res.data?.SCODE === "01" ? res.data.SDESC : []);
  };

  const IndicatorData = async (e) => {
    const selectedId = e.target.value;
    const filteredSector = indicatorlist?.filter((item) => item.id === selectedId.toString());
    setIndicatorname(filteredSector[0]?.value);
    formik.setFieldValue("indicator_id", selectedId);
    formik.setFieldValue("checkdata", []);
    await fetchSubIndicators(selectedId.toString());
  };

  const fetchSubIndicators = async (indicatorId) => {
    const params = { indicator_id: indicatorId, mandal_id: mandal };
    const res = await MasterService.getSubIndicators(params);
    if (res.data) {
      setData(res.data);
      setIndicatorStart(res.data[0]?.indicator_starts??[]);
      setStart(res.data[0]?.indicator_starts??[]);
    } else {
      setData([]);
      setIndicatorStart([]);
    setStart(1); 
    }
  };




  const saveData = async () => {
    const activeSubIndicators = formik.values.checkdata.filter(item => item?.is_active).map(item => ({ ...item, }));
    if (activeSubIndicators.length === 0) {
      ShowAlert("Please select at least one indicator to map", "warning");
      return;
    }
    const params = buildSaveParams(activeSubIndicators);
    store.dispatch({ type: "SHOW_SPINNER" });

    const res = await SwaranandhraService.getIndicatorMandalMapping(params);
    handleSaveResponse(res, activeSubIndicators);
  };

  const buildSaveParams = (activeSubIndicators) => ({
    userId: username,
    indicator_id: parseInt(formik.values.indicator_id),
    district_id: district,
    mandal_id: mandal,
    button_type: "insertData",
    indicator_start: indicatorStart,
    subIndicatorsList: activeSubIndicators
  });

  const handleSaveResponse = async (res, activeSubIndicators) => {
    if (res.data && res.data.SCODE === "01") {
      ShowAlert(res.data.SDESC, "success");
      formik.setFieldValue("checkdata", []);
      await fetchIndicatorMapping();
      await fetchSubIndicators(formik.values.indicator_id)
    } else if (res.data && res.data.SCODE === "02") {
      ShowAlert(res.data.SDESC, "warning");
    }
    resetCheckdata(activeSubIndicators);
    store.dispatch({ type: "HIDE_SPINNER" });
  };

  const resetCheckdata = (activeSubIndicators) => {
    const updatedValues = formik.values.checkdata.map(item => ({ ...item, is_active: false }));
    formik.setFieldValue("checkdata", updatedValues);
    const updatedValues1 = formik.values.checkdata1.map(item => ({ ...item, is_active1: false }));
    formik.setFieldValue("checkdata1", updatedValues1);
  };

  const handleCheckboxChange = (e, index) => {
    const { checked } = e.target;
    formik.setFieldValue(`checkdata1[${index}].is_active1`, checked);
  };

  const handleDelete = async (detail) => {
    const params = buildDeleteParams(detail);
    const res = await SwaranandhraService.getIndicatorMandalMapping(params);
    if (res.data && res.data.SCODE === "01") {
      ShowAlert("Deleted Successfully", "success");
      setData1(res.data?.SDESC);
      const filteredSector = indicatorlist?.filter((item) => item.id === detail.indicator_id.toString());
      setIndicatorname(filteredSector[0]?.value);
      formik.setFieldValue("indicator_id", detail.indicator_id);
      formik.setFieldValue("checkdata", []);
      await fetchSubIndicators(detail.indicator_id.toString());
    } else if (res.data && res.data.SCODE === "02") {
      ShowAlert(res.data?.SDESC, "warning");
    }
    resetCheckdata();
  };

  const buildDeleteParams = (detail) => ({
    userId: username,
    indicator_id: parseInt(detail.indicator_id),
    sub_indicator_id: parseInt(detail.sub_indicator_id),
    district_id: district,
    mandal_id: mandal,
    button_type: "deSelect"
  });




  const handleCheckboxChange1 = (e, index) => {
    const isChecked = e.target.checked;
    let updatedCheckdata = [...formik.values.checkdata];
    if (!filteredData[index]) {
      console.error('Filtered data index out of bounds');
      return;
    }
    updatedCheckdata[index] = {
      is_active: isChecked,
      sub_indicator_id: filteredData[index].id,
      indicator_starts: isChecked ? start : null
    };
    updateStartCount(updatedCheckdata);
    formik.setFieldValue('checkdata', updatedCheckdata);
  };

  const updateStartCount = (updatedCheckdata) => {
    const activeCheckboxes = updatedCheckdata.filter(item => item?.is_active);
    const newStart = activeCheckboxes.length > 0 ? Math.max(...activeCheckboxes.map(item => item?.indicator_starts)) + 1 : 1;
    setStart(newStart);
    formik.setFieldValue('checkAll', updatedCheckdata.every(item => item?.is_active));
  };





  const navigate = useNavigate();




  return (
    <>
      <Menubar />

      <Container fluid className='map-header mx-2'>
        <div className='sa-title'> <h2>Indicator <span>Activity Mapping</span></h2> </div>
      </Container>

      <Container fluid className='mt-5'>
        <div className='mandal-container p-4'>
          <Row>


            <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='sector-select'>
              <h5>Sector</h5>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <select className="form-control" defaultValue="indicator_id" value={formik.values.indicator_id} onChange={(e) => { IndicatorData(e) }} name="indicator_id"> <option value="">--Select--</option> {indicatorslist} </select>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>




      <Container fluid className='d-flex justify-content-end mt-2 mb-2'>
        <Row>
          <div> <Button  onClick={() => { navigate('/dataEntryForTargets') }} className='target-btn'>Target & Achievements Entry<ImNewTab className='ms-3' /></Button>{' '} <Button onClick={() => { exportToExcelindicator(filteredData1) }} className='excel-btn' ><RiFileExcel2Line className='me-2' /> Excel</Button>{' '} <Button  onClick={() => { generateindicatorpdf(filteredData1) }} className='pdf-btn'><VscFilePdf className='me-2' />Pdf</Button>{' '} </div>
        </Row>
      </Container>
      <Container fluid> <FormikProvider value={formik}> <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6}>
                <div className='indicators'>
                  <h5>{indicatorname || 'Select Indicators (or) Activity'}</h5>
                  <Form inline className='search-bar'>
                    <Row>
                      <Col> <input type="text" className="form-control border-0" placeholder="Search" onChange={(event) => setSearchText1(event.target.value)} /> </Col>
                    </Row>
                  </Form>


                  <div className='indicators-info'>
                    {filteredData?.map((detail, i) => (
                    
                        <div key={i} className="activity-box d-flex mt-2">
                          <Form>
                            <Field type="checkbox" name={`checkdata[${i}].is_active`} className="me-4 check-box-width" id="custom-checkbox" checked={formik.values.checkdata[i]?.is_active || false} onChange={(e) => handleCheckboxChange1(e, i)} style={{ transform: 'scale(1.4)' }} />
                          </Form>
                          <div className="number-box-main d-flex align-items-center">
                            <div className="number-box"><p>{i + 1}</p></div>
                            <div className="number-text"> <p>Indicator / Activity</p> <p>  {detail.value}</p> </div>
                          </div>
                          <div className="ha d-flex">
                            <div className="unit"><p>Unit</p></div>
                            <div className="ha-box text-center"><p>{detail.unit}</p></div>
                          </div>
                        </div>
                      ))
                    }




                  </div>
                </div>
                <Container fluid className='d-flex justify-content-end mt-2 mb-5 btn-map'>
                  <div className=''> <Button className='map-btn ' onClick={saveData}>Map Indicator / Activity<CiFloppyDisk className='ms-3' /></Button>{' '} </div>
                </Container>

              </Col>


              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6} className="agr-secto">

                <div className='indicators1'>
                  <h5>Mapped Indicators (or) Activity</h5>
                  <Form inline className='search-bar'>
                    <Row>
                      <Col> <input type="text" className="form-control border-0" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} /> </Col>
                    </Row>
                  </Form>

                  <div className='indicators-info' id="my-table">
                    {(() => {
                      let serialNumber = 0;
                      return filteredData1?.map((detail, i) => {
                        if (!detail.indicator_name) { serialNumber++; }
                        return (
                          <>
                            {detail.indicator_name ?
                              (
                                <div className='agriculture-head'> <h5>{detail.indicator_name} </h5> </div>
                              ) : (
                                <div key={i} className="activity-box d-flex mt-2">
                                  <div className="d-flex align-items-center number-box-main"> <div className="number-box"> <p>{serialNumber}</p> </div> <div className="number-text"> <p>Indicator / Activity</p> <p> {detail.sub_indicator_name}</p> </div> </div>

                                  <div className="d-flex ha"> <div className="unit"> <p>Unit</p> </div> <div className="ha-box text-center"> <p>{detail.unit}</p> </div> </div>

                                  <Form>
                                    <Field  name={`checkdata1[${i}].is_active1`} id={`custom-checkbox-${i}`} type="checkbox"  checked={formik.values.checkdata1[i]?.is_active1 || false} onChange={(e) => handleCheckboxChange(e, i)} className="ms-4 check-box-width me-2 " />
                                  </Form>
                                  {formik.values.checkdata1[i]?.is_active1 === true && ( <Button  size="sm" variant="" onClick={() => handleDelete(detail)}> <img src="../images/bin.webp" className="img-fluid bin-img" alt="delete" /> </Button> )}
                                </div>
                              )}</>
                        );});})()}
                  </div>
                </div>
              </Col> </Row> </Form> </FormikProvider>
      </Container>

    </>
  );
}

export default IndicatorMapping;
